import { baseUrl } from '@/config/env';
import request from '@/router/axios';
import { parseParam } from '@/util/util';

export const getUserPermission = () => {
    return request({
        url: `${baseUrl}/joins-sales-cloud/v1/menu/permission`,
        method: 'GET'
    })
}

export const getUserPermissionMenus = () => {
    return request({
        url: `${baseUrl}/joins-sales-cloud/v1/menu/permissionMenus`,
        method: 'GET'
    })
}

export const getUserPermissionMenusOperation = () => {
    return request({
        url: `${baseUrl}/joins-sales-cloud/v1/menu/permissionMenusOperation`,
        method: 'GET'
    })
}
// 材料权限
export const getUserPermissionMenusMaterial = () => {
    return request({
        url: `${baseUrl}joins-sales-cloud/v1/material_category/materialGroup`,
        method: 'GET'
    })
}
export const findSuperiorMenusByType = (type) => {
    return request({
        url: `${baseUrl}/joins-sales-cloud/v1/menu/findSuperiorMenusByType/${type}`,
        method: 'GET'
    })
}

export const findMenu = (params) => {
    params = parseParam(params)
    return request({
        url: `${baseUrl}/joins-sales-cloud/v1/menu?`+params,
        method: 'GET'
    })
}

export const findMenuAll = () => {
    return request({
        url: `${baseUrl}/joins-sales-cloud/v1/menu`,
        method: 'GET'
    })
}

export const addMenu = (data) => {
    return request({
        url: `${baseUrl}/joins-sales-cloud/v1/menu`,
        method: 'POST',
        data: data
    })
}

export const editMenu = (data) => {
    return request({
        url: `${baseUrl}/joins-sales-cloud/v1/menu`,
        method: 'PUT',
        data: data
    })
}

export const delMenu = (deleteOption, ids) => {
    let temp = ids.join(",")
    return request({
        url: `${baseUrl}/joins-sales-cloud/v1/menu/${temp}?option=${deleteOption}`,
        method: 'DELETE'
    })
}